import React from "react";

class ColorComboBox extends React.Component {
    constructor(props) {
        super(props);

        this.colors = [
            { name: "Bleu", value: "#0000FF" },
            { name: "Vert", value: "#00FF00" },
            { name: "Cyan", value: "#00FFFF" },
            { name: "Rouge", value: "#FF0000" },
            { name: "Magenta", value: "#FF00FF" },
            { name: "Jaune", value: "#FFFF00" },
            { name: "Blanc", value: "#FFFFFF" }
        ];
    }

    handleChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    };

    render() {
        return (
            <select

                value={this.props.value}
                onChange={this.handleChange}
                style={{
                    fontSize: "13px",
                    background: "#000000",
                    color: this.props.value,
                    boxSizing: "border-box",
                    border: "1px solid #808080",
                    borderRadius: "6px",                    
                    padding: "3px"
                }}
            >
                {this.colors.map((c) => (
                    <option
                        key={c.value}
                        value={c.value}
                        style={{
                            color: c.value,
                            fontSize: "12px"
                        }}
                    >
                        {c.name}
                    </option>
                ))}
            </select>
        );
    }
}

ColorComboBox.defaultProps = {
    value: "#FFFFFF"
};

export default ColorComboBox;